import { Injectable } from '@angular/core';
import { HttpService, VersionedData } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';
import { CustomerGroupDto } from '../dtos';

@Injectable()
export class CustomerGroupsService {
  private path = 'versionedupdate/customergroups';
  constructor(private httpService: HttpService) {}

  public getCustomerGroups(versionHash: string): Observable<VersionedData<CustomerGroupDto[]>> {
    return this.httpService.makeGet(`${this.path}/${versionHash}`);
  }
}
